import axios from '@/http'
//

//老师端-添加班级（Rahul
export function addClass(data) {
    return axios({
        url: '/api/jp-class/add-class',
        method: 'POST',
        data
    })
}
//老师端-续班（Rahul
export function renewClass(data) {
    return axios({
        url: '/api/jp-class/renew-class',
        method: 'POST',
        data
    })
}
//老师端-获取班级所有学生（Rahul
export function getJpstudents(data) {
    return axios({
        url: '/api/jp-class/get-students',
        method: 'GET',
        params: data
    })
}

//老师端-微信支付（Rahul
export function teaWeaPay(data) {
    return axios({
        url: '/api/jp-class/wechat-pay',
        method: 'POST',
        data
    })
}

// //老师端-教培学生列表（Rahul
// export function getJpStus(data) {
//     return axios({
//         url: '/api/jp-class/get-students',
//         method: 'POST',
//         data
//     })
// }

//老师端--获取订单信息（Rahul
export function getOrderInfo(data) {
    return axios({
        url: '/api/jp-class/get-order',
        method: 'GET',
        params: data
    })
}
//老师端--获取老师已支付订单列表（Rahul
export function getHasPay(data) {
    return axios({
        url: '/api/jp-class/get-orders',
        method: 'GET',
        params: data
    })
}



